export const DEFAULT_CREDIT_SCORE_CONFIG = {
    timingMaxPenalty: 65,
    timingMaxDays: 60,
    overdueRatioMaxPenalty: 20,
    overdueAgeMaxPenalty: 15,
    overdueAgeCapDays: 90,
    bands: [
        { min: 80, label: `Excellent` },
        { min: 60, label: `Good` },
        { min: 40, label: `Fair` },
        { min: 20, label: `Poor` },
        { min: 0, label: `High risk` },
    ],
    recencyHalfLifeDays: 180,
    paymentHistoryMonths: null,
};
/** Keys whose change only takes effect after contact stats are recalculated */
export const CREDIT_SCORE_SQL_KEYS = [`recencyHalfLifeDays`, `paymentHistoryMonths`];
function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
/** 0-100 payment behaviour score, or null when there is no history and nothing outstanding */
export function computeCreditScore(stats, config = DEFAULT_CREDIT_SCORE_CONFIG) {
    const hasHistory = stats.weightedAvgDaysLate !== null && stats.weightedAvgDaysLate !== undefined;
    const outstanding = Math.max(stats.outstandingHome || 0, 0);
    if (!hasHistory && outstanding <= 0) {
        return null;
    }
    let score = 100;
    if (hasHistory && stats.weightedAvgDaysLate > 0) {
        score -= clamp(stats.weightedAvgDaysLate / config.timingMaxDays, 0, 1) * config.timingMaxPenalty;
    }
    if (outstanding > 0) {
        const overdueRatio = clamp((stats.overdueHome || 0) / outstanding, 0, 1);
        score -= overdueRatio * config.overdueRatioMaxPenalty;
        score -= clamp((stats.oldestDaysOverdue || 0) / config.overdueAgeCapDays, 0, 1) * config.overdueAgeMaxPenalty;
    }
    return Math.round(clamp(score, 0, 100));
}
export function creditScoreBand(score, config = DEFAULT_CREDIT_SCORE_CONFIG) {
    var _a;
    if (score === null || score === undefined) {
        return null;
    }
    const band = [...config.bands]
        .sort((a, b) => b.min - a.min)
        .find(b => score >= b.min);
    return (_a = band === null || band === void 0 ? void 0 : band.label) !== null && _a !== void 0 ? _a : null;
}
//# sourceMappingURL=creditScore.js.map